import {
  EventEmitter,
  Directive,
  ElementRef,
  OnInit,
  AfterViewInit,
  SimpleChange,
  OnChanges,
  SimpleChanges,
  AfterViewChecked,
  Output,
} from '@angular/core'

@Directive({
  selector: 'appAddFormAttributes,[appAddFormAttributes]',
})
export class AddFormAttributesDirective implements AfterViewChecked {
  @Output() valuesUpdated = new EventEmitter<string>()

  constructor(private el: ElementRef) {}

  ngAfterViewChecked() {
    const nodeList = [
      ...this.el.nativeElement.querySelectorAll('input'),
      ...this.el.nativeElement.querySelectorAll('select'),
      ...this.el.nativeElement.querySelectorAll('textarea'),
    ]

    nodeList.forEach((item) => {
      switch (item.type) {
        case 'email':
        case 'number':
        case 'text': {
          item.setAttribute('value', item.value)
          break
        }
        case 'checkbox':
        case 'radio': {
          if (item.checked) {
            item.setAttribute('checked', item.checked)
          } else {
            item.removeAttribute('checked')
          }
          break
        }
      }
    })
  }
}
